import React from 'react';
import { Card } from 'react-bootstrap';
import type { BannerFilterProps } from './types';

const BannerFilters: React.FC<BannerFilterProps> = ({ showActiveOnly, setShowActiveOnly, totalBanners }) => {
  const handleActiveFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    console.info(`Setting active filter to: ${isChecked}`);
    setShowActiveOnly(isChecked);
  };

  return (
    <Card className="mb-4">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center m-2">
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="activeOnly"
              checked={showActiveOnly}
              onChange={handleActiveFilterChange}
            />
            <label className="form-check-label" htmlFor="activeOnly">
              <strong>Show Active Banners Only</strong>
            </label>
          </div>
          <div className="text-muted">
            Displaying {totalBanners} {showActiveOnly ? 'active' : ''} banners
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default BannerFilters;
